import React from "react";

const Newsletter = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 17.1429V3.92857C0 3.33482 0.459766 2.85714 1.03125 2.85714C1.60273 2.85714 2.0625 3.33482 2.0625 3.92857V16.7857C2.0625 17.3795 2.52227 17.8571 3.09375 17.8571C3.66523 17.8571 4.125 17.3795 4.125 16.7857V2.85714C4.125 1.28125 5.3582 0 6.875 0H19.25C20.7668 0 22 1.28125 22 2.85714V17.1429C22 18.7188 20.7668 20 19.25 20H2.75C1.2332 20 0 18.7188 0 17.1429ZM6.875 4.28571V7.14286C6.875 7.93304 7.48945 8.57143 8.25 8.57143H11C11.7605 8.57143 12.375 7.93304 12.375 7.14286V4.28571C12.375 3.49554 11.7605 2.85714 11 2.85714H8.25C7.48945 2.85714 6.875 3.49554 6.875 4.28571ZM7.90625 15C7.33477 15 6.875 15.4777 6.875 16.0714C6.875 16.6652 7.33477 17.1429 7.90625 17.1429H18.2188C18.7902 17.1429 19.25 16.6652 19.25 16.0714C19.25 15.4777 18.7902 15 18.2188 15H7.90625ZM6.875 11.7857C6.875 12.3795 7.33477 12.8571 7.90625 12.8571H18.2188C18.7902 12.8571 19.25 12.3795 19.25 11.7857C19.25 11.192 18.7902 10.7143 18.2188 10.7143H7.90625C7.33477 10.7143 6.875 11.192 6.875 11.7857ZM15.4688 6.42857C14.8973 6.42857 14.4375 6.90625 14.4375 7.5C14.4375 8.09375 14.8973 8.57143 15.4688 8.57143H18.2188C18.7902 8.57143 19.25 8.09375 19.25 7.5C19.25 6.90625 18.7902 6.42857 18.2188 6.42857H15.4688Z"
      fill={color}
    />
  </svg>
);

Newsletter.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Newsletter;
